import React, { Component } from "react";
import DoserGraph from "./DoserGraph"

import {
  getIrrigationEvents,
  getZone,
  getChannel,
  getRecipe,
  loadZoneInfo,
  loadChannelInfo,
  loadIrrigationVolume,
  loadRecipes,
  getVolume,
  loadRtdVals,
  senseIds,
  withTimeout,
} from "../C18AiUtils";
import {cl,getTime} from '../../../components/utils/utils';


const COL = {
  ZONE: "zoneName",
  CHANNEL: "channelName",
  START: "start",
  END: "end",
  RECIPE: "recipeName",
  VOLUME: "volume",
};

const graphWrap = {
  display: "flex",
  flexWrap: "wrap",
  gap: "12px",
}

const graphCell = {
  flex: "1 1 500px",
  maxWidth:400,
}

// const graphWrap = {
//   display: "flex",
//   flexWrap: "wrap",
//   gap: "12px",
//   width: "100%",
// }
//
// const graphCell = {
//   flex: "1 1 500px",
//   minWidth: 0,
// }

// const graphWrap = {
//   display: "flex",
//   flexWrap: "wrap",
//   gap: "12px",
// //   width:300,
//   width: "100%",
// }
//
// const graphCell = {
//   flex: "1 1 400px",
//   minWidth: 0,
// }

// const senseIds={
// // note gsEcId, etc. in C18AiUtils
//   EC: {ind:0,gsId:0,id:22529,min:0,max:3,color:"brown"},
//   pH: {ind:1,gsId:2,id:22537,min:4,max:10,color:"red"},
//   Temp: {ind:2,gsId:4,id:22545,min:20,max:100,color:"#408080"},
//   Flow: {ind:3,gsId:5,id:22549,min:0,max:100,color:"blue"},
// }

function normalizeEvents(raw) {
  if (raw == null) return [];
  if (Array.isArray(raw)) {
//     cl(raw)
    return raw
      .map((ev) => {
        const key =
          ev.key ??
          ev.k ??
          (ev.zInd != null && ev.ch != null ? `${ev.zInd}-${ev.ch}` : null);
        const start = Number(ev.start ?? ev.startTs ?? ev.fromTs ?? ev.t0);
        const end = Number(ev.end ?? ev.endTs ?? ev.toTs ?? ev.t1);
        if (key == null || key === "" || !Number.isFinite(start) || !Number.isFinite(end)) {
          return null;
        }
        return { key: String(key), start, end };
      })
      .filter(Boolean);
  }
  if (typeof raw === "object") {
    const out = [];
    Object.keys(raw).forEach((k) => {
      const ev = raw[k];
      if (!ev || typeof ev !== "object") return;
      const key = ev.key != null ? String(ev.key) : k;
      const start = Number(ev.start ?? ev.startTs ?? ev.fromTs ?? ev.t0);
      const end = Number(ev.end ?? ev.endTs ?? ev.toTs ?? ev.t1);
      if (!Number.isFinite(start) || !Number.isFinite(end)) return;
      out.push({ key: String(key), start, end });
    });
    return out;
  }
  return [];
}

function formatLocalTime(ts, tzo) {
//   cl(ts,tzo)
  const d = new Date((ts * 1000) + (tzo * 60 * 1000));
  let h = d.getUTCHours();
  const m = d.getUTCMinutes();
  const ampm = h >= 12 ? "pm" : "am";
  h = h % 12 || 12;
  let ret=`${h}:${String(m).padStart(2, "0")} ${ampm}`;
//   cl(ts,ret)
//   cl(ret)
  return `${h}:${String(m).padStart(2, "0")} ${ampm}`;
}

function cmpField(a, b, field, dir) {
  const mult = dir === "asc" ? 1 : -1;
  let va = a[field];
  let vb = b[field];
  if (field === COL.ZONE || field === COL.CHANNEL || field === COL.RECIPE) {
    return mult * String(va ?? "").localeCompare(String(vb ?? ""));
  }
  if (field === COL.VOLUME) {
    const aMissing = typeof a.volume !== "number";
    const bMissing = typeof b.volume !== "number";
    if (aMissing && bMissing) return 0;
    if (aMissing) return 1;
    if (bMissing) return -1;
    return mult * (a.volume - b.volume);
  }
  va = Number(va);
  vb = Number(vb);
  if (!Number.isFinite(va)) va = 0;
  if (!Number.isFinite(vb)) vb = 0;
  return mult * (va - vb);
}

export default class DoserDataLog extends Component {
  state = {
    rows: [],
    loading: true,
    loadError: null,
    sortBy: COL.START,
    sortDir: "desc",
  };

  async componentDidMount() {
    const { siteId, zoneId } = this.props;
    const now = Math.floor(Date.now() / 1000);
    const fromTs = now - 7 * 24 * 60 * 60;
//     cl(this.props)
    var graphs
    try {
//       cl("get")
      await withTimeout(Promise.all([
        loadZoneInfo(siteId),
        loadChannelInfo(siteId),
        loadRecipes(zoneId),
        loadIrrigationVolume(zoneId, fromTs, now),
      ]),5000);
//       await Promise.all([
//         loadZoneInfo(siteId),
//         loadChannelInfo(siteId),
//         loadRecipes(zoneId),
//         loadIrrigationVolume(zoneId, fromTs, now),
//       ]);
//       let inds=Object.keys(senseIds).map(id=>senseIds[id].ind)
//       cl(inds)
//       cl("get")
      let rtdVals=await withTimeout(loadRtdVals(zoneId,null,fromTs,now),20000)
//       cl(rtdVals)
      if(rtdVals=="to"){rtdVals={}}
//       cl("get")
      graphs={
        rtdVals:rtdVals,
        fromTs:fromTs,
        toTs:now,
      }
//       cl(rtdVals)
//       cl(graphs)

      var eventsRaw = await getIrrigationEvents(siteId, fromTs, now);
//       cl(eventsRaw)
      const events = normalizeEvents(eventsRaw)
        .filter(e=>(this.props?.valves||[]).includes(e.key))
//       cl(events)
//       cl(this.props.valves)
      const rows = events
        .map((ev) => this.buildRow(ev, siteId, zoneId))
        .filter(Boolean);
//       cl(rows)

      this.setState({ rows, loading: false, loadError: null,
        graphs:graphs
      });
    } catch (err) {
//       var err
      cl(err)
      this.setState({ rows: [], loading: false, loadError: err
      });
    }
    setInterval(this.updGraphs,60*1000)
  }

  buildRow(ev, siteId, zoneId) {
    const { key, start, end } = ev;
    const {tzo,mode}=this.props
    let zoneInd = null,
      channelInd = null;
    if (typeof key === "string" && key.includes("-")) {
      const parts = key.split("-");
      zoneInd = Number(parts[0]);
      channelInd = Number(parts[1]);
    }

    const zone =
      Number.isFinite(zoneInd) && Number.isFinite(channelInd)
        ? getZone(siteId, zoneInd)
        : null;
    const channel =
      Number.isFinite(zoneInd) && Number.isFinite(channelInd)
        ? getChannel(siteId, zoneInd, channelInd)
        : null;
    const recipe = getRecipe(zoneId, start, tzo, mode);

    let volume = "—";
    try {
      const v = getVolume(zoneId, start, end);
//       cl(v)
      if (v != null && !isNaN(v)) {
        volume = v;
      }
    } catch {}

    return {
      zoneName: zone?.zoneName || "—",
      channelName: channel?.channelName || "—",
      recipeName: recipe?.recipeName || recipe?.name || "—",
      contTzo:zone?.contTzo,
      start,
      end,
      volume,
    };
  }

  onSort = (columnKey) => {
    this.setState((prev) => {
      if (prev.sortBy === columnKey) {
        return { sortDir: prev.sortDir === "asc" ? "desc" : "asc" };
      }
      return { sortBy: columnKey, sortDir: "asc" };
    });
  };

  getSortedRows() {
    const { rows, sortBy, sortDir } = this.state;
//     cl(rows)
    const sorted = [...rows].filter(Boolean).sort((a, b) => {
      let c = cmpField(a, b, sortBy, sortDir);
      if (c !== 0) return c;
      if (sortBy !== COL.START && sortBy !== COL.END) {
        c = cmpField(a, b, COL.START, "asc");
        if (c !== 0) return c;
      }
      return a.start - b.start;
    });
//     cl(sorted)
    const visible = sorted.slice(0, 20);
    return visible;
  }

  renderHeaderCell(label, columnKey) {
    const { sortBy, sortDir } = this.state;
    const active = sortBy === columnKey;
    const arrow = active ? (sortDir === "asc" ? " ▲" : " ▼") : "";
    return (
      <th
        style={{
          padding: "6px",
          textAlign: "left",
          cursor: "pointer",
          userSelect: "none",
          borderBottom: "1px solid #ccc",
        }}
        onClick={() => this.onSort(columnKey)}
      >
        {label}
        {arrow}
      </th>
    );
  }

  updGraph=async(graphs,si)=>{
    if(!graphs){return}
    let {zoneId}=this.props
    let now=Math.floor(getTime())
    let fromTs=now-7*86400
    graphs.fromTs=fromTs
    graphs.toTs=now
    let rtdVals=await loadRtdVals(zoneId,si.gsId,fromTs,now)
    graphs.rtdVals[si.id]=rtdVals[si.id]
    this.setState({graphs:graphs})
  }

  updGraphs=async()=>{
    let {graphs}=this.state
    for(let key of Object.keys(senseIds)){
      let si=senseIds[key]
      await this.updGraph(graphs,si)
    }
    this.setState({graphs:graphs})
  }

  render() {
    let st=this.state
    const {units}=this.props
//     let pr=this.props
    const { tzo } = this.props;
    const { loading, loadError, rows } = this.state;
    const visible = this.getSortedRows();
//     cl(visible)
    const grUnits={
      EC:"mS",
      pH:"",
      Temp:units.t,
      Flow:`${units.v}/Min`
    }
    var graphs=[]
    if(st.graphs){
      graphs=Object.keys(senseIds).filter(k=>st.graphs.rtdVals[senseIds[k].id])
        .map(k=>{
        let si=senseIds[k]
//         cl(st.graphs.rtdVals[si.id])
        let data=st.graphs.rtdVals[si.id].filter(d=>+d.v!=1e4)
//         if(k=="Flow"){cl(data)}
        return(
          <div key={k} style={graphCell}>
            <DoserGraph
              title=<span>{`${k}${grUnits[k]?`(${grUnits[k]})`:""}`}</span>
              unit={grUnits[k]}
              color={si.color}
              yDom={[si.min,si.max]}
              autoRange={k==="Flow"}
              width="380"
              height="150"
              data={data}
              tzo={tzo}
            />
          </div>
        )
      })
    }
//     cl(loadError,visible)

    const cellPad = { padding: "6px" };
//     cl(this.state)
//     cl(visible)
    return (
      <div style={{ fontFamily: "system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif" }}>
        <div style={graphWrap}>
          {graphs}
        </div>
        <h2 style={{ fontSize: "18px", fontWeight: 700, marginBottom: "12px" }}>
          Pearl iDoser Data Log
        </h2>

        {loadError && (
          <div style={{ color: "#b71c1c", marginBottom: "8px" }}>
            {String(loadError.message || loadError)}
          </div>
        )}

        {loading ? (
          <div>Loading...</div>
        ) : !loadError && rows.length === 0 ? (
          <div>No fertigation events in the last 24 hours</div>
        ) : rows.length > 0 ? (
          <div style={{ maxHeight: "400px", overflowY: "auto" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "14px",
              }}
            >
              <thead>
                <tr style={{ fontWeight: "bold" }}>
                  {this.renderHeaderCell("Zone", COL.ZONE)}
                  {this.renderHeaderCell("Channel", COL.CHANNEL)}
                  {this.renderHeaderCell("Start", COL.START)}
                  {this.renderHeaderCell("End", COL.END)}
                  {this.renderHeaderCell("Recipe", COL.RECIPE)}
                  {this.renderHeaderCell("Volume", COL.VOLUME)}
                </tr>
              </thead>
              <tbody>
                {visible.map((row, idx) => (
                  <tr
                    key={`${row.zoneName}-${row.channelName}-${row.start}-${row.end}-${idx}`}
                    style={{ backgroundColor: idx % 2 === 1 ? "#fafafa" : "#fff" }}
                  >
                    <td style={cellPad}>{row.zoneName}</td>
                    <td style={cellPad}>{row.channelName}</td>
                    <td style={cellPad}><>{formatLocalTime(row.start, tzo)}
                    {(row.contTzo!=0-tzo)&&
                      <span style={{color:"red"}}
                      title="The timezone of the controller is different than the site"
                      >&nbsp;(TZ Err)</span>
                    }</>
                    </td>
                    <td style={cellPad}>{formatLocalTime(row.end, tzo)}</td>
                    <td style={cellPad}>{row.recipeName}</td>
                    <td style={cellPad}>
                      {typeof row.volume === "number" && !isNaN(row.volume)
                        ? `${row.volume.toFixed(1)} ${units.v}`
                        : "—"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : null}
      </div>
    );
  }
}
